/**
 * Auth 서버 API 인스턴스
 *
 * openapi-fetch 기반의 타입 안전한 API 클라이언트
 */
import { stepinMiddleware } from '@/@shared/middleware/middleware';
import type { paths } from '@/domains/auth/types/schema';
import { API_CONFIG } from '@/model/openAPI/config';
import createClient from 'openapi-fetch';

/**
 * Auth 서버 클라이언트 생성 함수
 */
const createAuthClient = () => {
	const client = createClient<paths>({
		baseUrl: API_CONFIG.auth.baseUrl,
	});

	// 공통 미들웨어 적용
	client.use(stepinMiddleware);

	return client;
};

/**
 * Auth 서버 싱글톤 인스턴스
 */
export const authFetcher = createAuthClient();

/**
 * HTTP 메서드별 함수들 export
 */
export const { GET, POST, PUT, PATCH, DELETE } = authFetcher;

/**
 * 타입 export
 */
export type AuthFetcher = typeof authFetcher;
export type AuthPaths = paths;
